export const toCoords = (string: string): [number, number] | null => {
  try {
    const coords = string.split(`,`);

    // eslint-disable-next-line
    if (coords.length === 2 && coords[0] !== `` && !isNaN(+coords[0]) && coords[1] !== `` && !isNaN(+coords[1])) {
      const lat = parseFloat(coords[0]);
      const lng = parseFloat(coords[1]);
      return [lat, lng];
    }
  } catch (error) {
    return null;
  }
  return null;
};
